import Axios from "./axios";

const resource = "reseller-shop-plans";

export default {
	get(params) {
		return Axios.get(`${resource}`, params);
	},
	show(id) {
		return Axios.get(`${resource}/${id}`);
	}
}